export enum ToastPosition {
  // eslint-disable-next-line no-unused-vars
  TOP,
  // eslint-disable-next-line no-unused-vars
  CENTER,
  // eslint-disable-next-line no-unused-vars
  BOTTOM
}

export class Timer {
  _callback: () => void
  _timerId
  _start: number
  _remaining: number

  constructor (callback: () => void, delay: number) {
    this._callback = callback
    this._remaining = delay
    this.resume()
  }

  pause () {
    clearTimeout(this._timerId)
    this._remaining -= Date.now() - this._start
  }

  resume () {
    this._start = Date.now()
    clearTimeout(this._timerId)
    this._timerId = setTimeout(this._callback, this._remaining)
  }

  clear () {
    clearTimeout(this._timerId)
  }
}

export function generateUEID () {
  const first = (Math.random() * 46656) | 0
  const second = (Math.random() * 46656) | 0
  const lead = (`000${first.toString(36)}`).slice(-3)
  const tail = (`000${second.toString(36)}`).slice(-3)
  return lead + tail
}
